"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var FilterOption = function FilterOption(_ref) {
  var item = _ref.item,
      data = _ref.data,
      onFilterOptionSelection = _ref.onFilterOptionSelection,
      type = _ref.type,
      key = _ref.key;
  return (0, _preact.h)(_InputGroup.default, {
    inline: true,
    key: key !== null && key !== void 0 ? key : item.id,
    value: String(item.value),
    title: (0, _preact.h)("div", null, typeof item.avatar !== 'undefined' && (0, _preact.h)(_UserAvatar.default, {
      disableLink: true,
      disablePopup: true,
      user: item
    }), item.icon && (0, _preact.h)(_assets.default, {
      icon: item.icon
    }), item.name),
    formGroupClasses: "overview__filters-box-filter",
    checked: data.some(function (value) {
      return String(value) === String(item.value);
    }),
    type: type === 'radio' ? 'radio' : 'checkbox',
    onChangeCheckbox: type === 'radio' ? function (e) {
      onFilterOptionSelection([e.target.value]);
    } : function (e) {
      var value = e.target.value;
      var checked = e.target.checked;
      var payload = checked ? [].concat((0, _toConsumableArray2.default)(data), [value]) : data.filter(function (x) {
        return String(x) !== value;
      });
      onFilterOptionSelection(payload);
    }
  });
};

var _default = FilterOption;
exports.default = _default;